import { IExperiments } from '../../../../../types/reducers/experiments';
import { servicesCardsTextsExperimentName, TExperiments } from '../../../../../constants/experiments';

interface ITexts {
  title: string;
  subtitle: string;
}

export const controlGroup = {
  title: 'Продвижение в поиске',
  subtitle: 'Используйте, чтобы опередить конкурентов и получить больше звонков',
};

export const bGroup = {
  title: 'Получите больше просмотров',
  subtitle: 'Покажем объявление тем, кто ищет похожие объекты',
};

export const cGroup = {
  title: 'Получите больше показов',
  subtitle: 'Покажем объявление тем, кто ищет похожие объекты',
};

export const getHeaderTexts = (experiments: IExperiments, allExperiments: TExperiments): ITexts => {
  if (experiments[servicesCardsTextsExperimentName]) {
    const groups = allExperiments[servicesCardsTextsExperimentName];

    switch (experiments[servicesCardsTextsExperimentName]) {
      case groups?.default: {
        return controlGroup;
      }
      case groups?.shows: {
        return cGroup;
      }
      case groups?.views: {
        return bGroup;
      }
      case groups?.redesign: {
        return controlGroup;
      }
    }
  }

  return controlGroup;
};
